import {Component, ComponentRef, OnInit} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CodeInputModule} from "angular-code-input";
import {Overlay, OverlayRef} from "@angular/cdk/overlay";
import {Router, RouterModule} from "@angular/router";
import {AuthenticationService} from "../../../../domain/services/auth/authentication.service";
import {DialogService} from "../../../../domain/services/dialog/dialog.service";
import {CommonModule, NgClass} from "@angular/common";
import {ToasterService} from "../../../../common/toaster/toaster.service";
import {finalize} from "rxjs";

@Component({
  selector: 'app-email-confirmation',
  standalone: true,
  imports: [
    CommonModule,
    MatButton,
    MatIcon,
    FormsModule,
    CodeInputModule,
    RouterModule,
    NgClass,
    ReactiveFormsModule,
  ],
  templateUrl: './email-confirmation.component.html',
  styleUrl: './email-confirmation.component.css'
})
export class EmailConfirmationComponent implements OnInit {
  private overlayRef!: OverlayRef;
  code : string ='';
  codeComplete : boolean = false;
  email: string = '';

  constructor(private readonly router: Router,
              private readonly authenticationService: AuthenticationService,
              private readonly dialogService: DialogService,
              private overlay: Overlay,
              private readonly toasterService: ToasterService) {
  }

  ngOnInit(): void {
    this.email = this.authenticationService.getEmailToReset();
    if (!this.email) {
      this.router.navigate(['auth/login']);
    }
    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay
        .position()
        .global()
        .top("20px")
        .right("30px"),
    });
  }

  onCodeChanged(code: string) {
    this.code = code;
  }

  onCodeCompleted(code: string) {
    this.codeComplete = true;
  }

  resendCode(): void {
    this.authenticationService.requestPasswordReset(this.email).pipe(finalize(() => {
      this.toasterService.show('success', 'Code sent successfully', `Verification code sent to ${this.email}`);
    })).subscribe();
  }

  validateCode(){
    this.authenticationService.validateCode(this.email, this.code).subscribe(value => {
      this.toasterService.show('success', 'Confirmation code validated', 'Your confirmation code was correct');
    this.router.navigate(['auth/change-password']);
    }, error => {
      this.toasterService.show('error', 'Invalid code', 'Your confirmation code was incorrect');
    });
  }
}

